import { useEffect, useRef } from 'react';

const useOutsideClick = callback => {
  const ref = useRef();

  useEffect(() => {
    const handleClick = event => {
      // event.preventDefault();
      // event.stopPropagation();
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    };

    document.addEventListener('click', handleClick, true);

    return () => {
      document.removeEventListener('click', handleClick, true);
    };
  }, [ref, callback]);

  return ref;
};

export default useOutsideClick;
